/** @format */

import { AddressTypeList } from "../constants/constants";

export const checkValidAddress = (userSingleaddress) => {
  const addressValid =
    userSingleaddress?.locality &&
    userSingleaddress?.latitude &&
    userSingleaddress?.longitude &&
    userSingleaddress?.pincode &&
    userSingleaddress.metaData?.name &&
    userSingleaddress.metaData?.phone &&
    userSingleaddress?.city &&
    userSingleaddress?.addressTag &&
    userSingleaddress?.addressType &&
    userSingleaddress?.address &&
    userSingleaddress?.state &&
    userSingleaddress?.stateCode;

  return addressValid;
};

export const calculateTagStatusAndUserAddressType = (
  isEditAddress,
  fetchedAddress,
  userAddresses
) => {
  const checkAddressType = userAddresses
    .filter((item) =>
      [AddressTypeList.Home, AddressTypeList.Office].includes(
        item.addressTag.toUpperCase()
      )
    )
    .map((item) => item.addressTag.toUpperCase());

  const result = checkAddressType.sort();

  let userAddressType;
  const tagStatusMap = {
    Home: "enabled",
    Office: "enabled",
    Other: "enabled",
  };

  if (isEditAddress) {
    userAddressType = fetchedAddress?.addressType;

    if (fetchedAddress?.addressTag === AddressTypeList.Home) {
      tagStatusMap.Home = "selected";
      tagStatusMap.Office = result.includes(AddressTypeList.Office)
        ? "disabled"
        : "enabled";
    } else if (fetchedAddress?.addressTag === AddressTypeList.Office) {
      userAddressType = fetchedAddress?.addressType;
      tagStatusMap.Office = "selected";
      tagStatusMap.Home = result.includes(AddressTypeList.Home)
        ? "disabled"
        : "enabled";
    } else {
      tagStatusMap.Home = result.includes(AddressTypeList.Home)
        ? "disabled"
        : "enabled";
      tagStatusMap.Office = result.includes(AddressTypeList.Office)
        ? "disabled"
        : "enabled";
      tagStatusMap.Other = "selected";
    }
  } else {
    if (result.length === 0) {
      userAddressType = 1;
      tagStatusMap.Home = "selected";
      tagStatusMap.Office = "enabled";
      tagStatusMap.Other = "enabled";
    } else if (
      result.includes(AddressTypeList.Home) &&
      result.includes(AddressTypeList.Office)
    ) {
      userAddressType = 3;
      tagStatusMap.Home = "disabled";
      tagStatusMap.Office = "disabled";
      tagStatusMap.Other = "selected";
    } else if (result.includes(AddressTypeList.Home)) {
      userAddressType = 2;
      tagStatusMap.Home = "disabled";
      tagStatusMap.Office = "selected";
      tagStatusMap.Other = "enabled";
    } else if (result.includes(AddressTypeList.Office)) {
      userAddressType = 1;
      tagStatusMap.Home = "selected";
      tagStatusMap.Office = "disabled";
      tagStatusMap.Other = "enabled";
    }
  }

  return { tagStatusMap, userAddressType };
};

export const removeDuplicateValues = (address) => {
  if (!address?.locality) return "";

  const { locality, city, state, pincode } = address || {};
  const regexPattern = new RegExp(`(${city},|${state} ${pincode},?|${state}(?:,|$)|${pincode},|India)`, "gi");

  const modifiedLocality = locality
    .replace(regexPattern, "")
    .replace(/\s*,\s*,/g, "")
    .replace(/,\s*$/, "")
    .replace(/\s+/g, " ")
    .trim();

  return !!modifiedLocality?.length ? modifiedLocality : locality;
};
